import React from 'react'


const Header = () => {
  return (
   
    <div className=''> <h1 className='mt-5 text-center titulo'>QUIZ GAME F1</h1>
    
    </div>
  )
}

export default Header